import { gql } from '@apollo/client'
import { useCleanFilterForRequest, useSearch, useSort } from '@btime/react-contexts'
import React from 'react'

import { formsClient } from '../../../../utils/apollo/api'
import { useForm } from './FormLoader'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../components/helpers/LazyAction'
import StatePresenter from '../../../../components/helpers/StatePresenter'
import { convertFilterToRelativeDates } from '../../../../utils/helpers/date'

const Context = React.createContext()
const { Provider } = Context
export const useFormRepliesState = () => React.useContext(Context) || {}
export const useFormReplies = () => useFormRepliesState()?.formReplies || []

const QUERY = gql`
  query FormReplies($page: Int, $search: String, $sort: FormReplySort, $filter: FormReplyFilter) {
    formReplies(page: $page, search: $search, sort: $sort, filter: $filter) {
      id
      number
      insertedAt
      formId
      serviceOrdersCount
      place {
        id
        name
        resume
      }
    }
  }
`

const FormRepliesLoader = ({ children, uncontrolledChildren }) => {
  const { field, type } = useSort()
  const search = useSearch()
  const form = useForm()
  let filter = useCleanFilterForRequest()
  filter = convertFilterToRelativeDates(filter)

  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      search,
      filter: { ...filter, formIds: form.id },
      sort: { field: field || 'NUMBER', type: type || (!field ? 'DESC' : 'ASC') }
    },
    client: formsClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading || state.isFetchingMore} />
      </StatePresenter>
    </Provider>
  )
}

export default FormRepliesLoader
